import type { ProductListItem } from 'types/capi/shared';

import {
  type ContractStockStatus,
  toContractStockStatus
} from '~/domain/stockStatus';

import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';

const NO_PRICE = -1;

export type ProductCardImpressionProperties = {
  position?: number;
  price_currency: string;
  price_regular: number;
  price_sale?: number;
  product_id: string;
  stock_status: ContractStockStatus;
  surface?: string;
};

type EventData = {
  isBot: boolean;
  position?: number;
  product: ProductListItem;
  surface?: string;
};

class ProductCardImpressionEvent extends ImpressionEvent<
  EventData,
  ProductCardImpressionProperties
> {
  protected get impressionType(): ImpressionType {
    return 'product_card';
  }

  protected getImpressionProperties(): ProductCardImpressionProperties {
    return {
      position: this.data.position ?? this.data.product.position,
      price_currency: this.data.product.price.currency,
      price_regular: this.data.product.price.regular ?? NO_PRICE,
      price_sale: this.data.product.price.sale ?? undefined,
      product_id: String(this.data.product.id),
      stock_status: toContractStockStatus(this.data.product.stock_status),
      surface: this.data.surface
    };
  }
}

export default ProductCardImpressionEvent;
